<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import commonTop from "@/components/commonTop.vue";
import {Message} from 'element-ui'

export default {
    components: { commonTop},
    data() {
        return {
            xieyi_options: [{
                value: true,
                label: '是'
                }, {
                value: false,
                label: '否'
                }],
            commonTopData: {
                pageName: "newsRelease",
                commonleftbtn: [],     
            },
            form: {
                files: [],
                previewFiles: '',
                gifFiles: '',
                name: '',
                sort: '',
                file_info_json: '',
                options: [],
                value: '',
                status: '1',
                versionCode: '',
                filesLength: [],
                is_has_protocol:false,
                protocol_id:'',
                fileName:'',
                file_size:''
            },
            rules: {
                name: [
                    { required: true, message: '请输入版本名称', trigger: 'blur' },
                    { min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur' }
                ],
                value: [
                    { required: true, message: '请选择模板分类', trigger: 'change' }
                ],
                sort: [
                    { required: true, message: '请输入排序权重', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择上架状态', trigger: 'change' }
                ],
                versionCode: [
                    { required: true, message: '请填写详细说明', trigger: 'blur' }
                ]
            },
            protocol_list:[],
            is_protocol:false
        };
    },
    watch:{
        'form.is_has_protocol'(val){
            if(val == true||val == '是'){
                this.is_protocol = true
            }else{
                this.is_protocol = false
            }
        }
    },
    computed: {
        previewFiles() {
            return this.form.previewFiles ? [{ url: this.form.previewFiles }] : []
        },
        gifFiles() {
            return this.form.gifFiles ? [{ url: this.form.gifFiles }] : []
        }
    },
    mounted(){
        this.api.lockscreen_protocolList({status:1}).then((da) => {
            this.protocol_list = da.data.map((val)=>{
                return{
                    ...val,
                    value:val.id,
                    label:val.name
                }
            })
		})
    },
    methods: {
        fileChange(files) {
            console.log(files,'files files')
            this.form.filesLength = files
            this.form.file_info_json  = files[0].response.data.file_info_json
            if(files[0].response.data.file_type != 'zip'){
                this.$message.error('上传模板脚本包只能是 zip 格式!')
                this.form.files = [];
            }else{
                this.form.files = files.slice(-1)
            }
        },
        handleChange(list) {
            if(list.length) {
				let img = list.splice(-1);

                this.$emit("input", img[0].url);
			}
        },
        gifChange(list) {
            if(list.length) {
				let img = list.splice(-1);

                this.$emit("input", img[0].url);
			}
        },
        async getData() {
            let data = await this.api.detailProjectTmplate({
                access_token: localStorage.getItem("access_token"),
                id: this.$route.query.id
            })
            if(data) {
                console.log(data.file_name,'初始化数据')
                let files = [{name: data.fileName||data.file_name,url: data.templateFootPackage,response:{data:{file_size:data.fileSize,file_name:data.fileName||data.file_name,url: data.templateFootPackage}}}];
                let list = this.form.options;
                this.form = {
                   name: data.name,
                    value: data.type,
                    enName: data.en_name,
                    sort: data.sort_weight,
                    previewFiles: data.preview_pic,
                    file_info_json: data.file_info_json,
                    gifFiles :data.preview_video,
                    status: data.status,
                    versionCode: data.desc,
                    fileUrl: data.file_url || data.fileUrl,
                    fileName :data.file_name||data.fileName,
                    files: files,
                    options: list,
                    is_has_protocol:(data.isHasProtocol=='1' || data.is_has_protocol=='1')?true:false,
                    protocol_id:data.protocol_id || data.protocolId,
                    file_size:data.file_size || data.fileSize
                }
            }
        },
        async setLockScreenConfig() {
            if(!this.form.previewFiles){
                Message({message: '请上传模板预览图',type: 'warning'});
                return
            }
            if(this.form.files.length == 0 || (this.form.filesLength && this.form.filesLength.length == 0)){
                Message({message: '请上传模板脚本包',type: 'warning'});
                return
            }
            if(this.is_protocol){
        
                if(!this.form.protocol_id){
               
                    Message({message: '请选择协议类型',type: 'warning'});
                    return
                }
            }
            if(!this.form.value || this.form.value.length==0){
                Message({message: '请选择分类',type: 'warning'});
                return
            }
            let url = 'addProjectTmplate';
            let params = {};
            params.access_token = localStorage.getItem("access_token");
            params.name = this.form.name
            params.en_name = this.form.enName
            params.type = typeof this.form.value=='string'?this.form.value:this.form.value[this.form.value.length-1]
            params.sort_weight = this.form.sort;
            params.preview_pic = this.form.previewFiles || this.form.previewFiles
            params.preview_video = this.form.gifFiles || this.form.gifFiles
            params.file_url = this.form.files[0].response.data.url || this.form.fileUrl || this.form.file_url
            params.file_name = this.form.files[0].response.data.file_name || this.form.fileName  || this.form.file_name
            params.file_size = this.form.files[0].response.data.file_size || this.form.fileSize || this.form.file_size 
            params.status = this.form.status
            params.desc = this.form.versionCode
            params.file_info_json = JSON.stringify(this.form.files[0].response.data.file_info_json)
            params.is_has_protocol = this.is_protocol?1:0
            if(this.is_protocol){
                params.protocol_id = this.form.protocol_id
            }
            if (this.$route.query.edit == 2) {
                url = "editProjectTmplate"
                let obj = {id:this.$route.query.id,file_info_json:JSON.stringify(this.form.file_info_json)}
                Object.assign(params,obj);
            }
            let data = await this.api[url](params)
            if(data) {
                this.$message({
                    type: 'success',
                    message: data
                })
                // this.back();
                let query = this.$route.query.edit == 2 && localStorage.getItem('screen_form')?{
                    tabsnum:1,
                    screen_form:localStorage.getItem('screen_form')
                }:{
                    tabsnum:1
                }
                this.$router.push({path:'/new/set-lock-screen',query:query}); 
            }
        },
        async init(){
            const token = localStorage.getItem("access_token")
            let data = await this.api.Lockscreen({
                access_token: token,
                type:2
            })
            if(data) {
                this.form.options = data[0].child
            }
        },
        save(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.setLockScreenConfig()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        back() {
            let query = this.$route.query.edit == 2 && localStorage.getItem('screen_form')?{
                tabsnum:1,
                screen_form:localStorage.getItem('screen_form')
            }:{
                tabsnum:1
            }
            this.$router.push({path:'/new/set-lock-screen',query:query});
        },
        beforeAvatarUpload(file){
            const isLt1M = file.size / 1024 / 1024 < 0.09765625;
            if (!isLt1M) {
                this.$message.error('上传头像图片大小不能超过 100kb!');
            }
            return isLt1M;
        },
        httprequest(params) {
            const _file = params.file;
            this.file = params.file
            let _this = this
            let app_secret = '1Q61s1iP8I376GyMTdsjOzd4hcLpZ4SG';
            let open_id = 7;
            let times = (Date.parse(new Date()) / 1000);
            let arr = [
                1003,
                app_secret,
                open_id,
                times
            ];

            // 通过 FormData 对象上传文件
            var formData = new FormData();
            formData.append("file", _file);
            formData.append('app_id', 1003); 
            formData.append('sign', this.MD5(encodeURIComponent(arr.sort())))
            formData.append('user', open_id)
            formData.append('relation_type', 'activity')
            formData.append('timestamp', times)
            _this.$parent.setpercentage("start");
            this.axios.post(window.file_upload_baseURL, formData).then(function(response) {  

            const fileName = response.data.data.url.lastIndexOf('.');
            const fileNameLen = response.data.data.url.length;
            const fileTypeName = response.data.data.url.substring(fileName + 1, fileNameLen).toUpperCase();
            if(fileTypeName == 'MP4'){
                _this.form.gifFiles = response.data.data.url
            } else{
                _this.form.previewFiles = response.data.data.url;
            }
            _this.$parent.setpercentage("end", response.data.data.url);
            }).catch(function(error) {
                console.log(error);
            });
        },
        setimgurl(url) {
            const fileName = url.lastIndexOf('.');
            const fileNameLen = url.length;
            const fileTypeName = url.substring(fileName + 1, fileNameLen).toUpperCase();
            if(fileTypeName == 'MP4'){
                this.form.gifFiles = url
            }else{
                this.form.previewFiles = url;
            }
        }
    },
    created() {
        this.init();
        if(this.$route.query.id != undefined){
            this.getData();
        }
    },
};
</script>
